import "./styles/home.css"

export default function Home() {
    return (
        <section id="home-page">
            <div>
                <h1>Metalhead, Tech Enthusiast, Competitive Coder</h1>
            </div>
        </section>
    );
}